import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import Swal from 'sweetalert2';
import { MdDeleteForever } from 'react-icons/md';
import { BsFillPencilFill } from 'react-icons/bs';
import Select from 'react-select';
import { useMediaQuery } from 'react-responsive';
import { axiosAuth } from '../../../../api';

function ModalUbahCustomer({
    rowSelected,
    showEditCustomer,
    setShowEditCustomer,
    retrieveCustomer,
    accessToken,
}) {

    const { userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 736 });
    const { theme } = useContext(ThemeContext);

    const handleClose = () => {
        setShowEditCustomer(false);
    };

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [customerTitle, setCustomerTitle] = useState([]);
    const [customerType, setCustomerType] = useState([]);
    const [customerAddress, setCustomerAddress] = useState([]);

    const retrieveCustomerTitle = () => {

        axiosAuth.get(`/api/customers/titles`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setCustomerTitle(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrieveCustomerType = () => {

        axiosAuth.get(`/api/customers/types`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setCustomerType(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrieveCustomerAddress = () => {

        axiosAuth.get(`/api/customers/addresses?customerId=${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setCustomerAddress(res.data.data);

            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveCustomerTitle();
        if (accessToken !== undefined) retrieveCustomerType();
    }, [accessToken]);

    useEffect(() => {
        if (accessToken !== undefined && rowSelected?.id !== undefined) retrieveCustomerAddress();
    }, [accessToken, rowSelected?.id]);

    const defaultValue = {
        creditScore: rowSelected?.creditScore || "",
        titleId: rowSelected?.title.id || "",
        customerName: rowSelected?.name || "",
        email: rowSelected?.email || "",
        customerTypeId: rowSelected?.customerType?.id || '',
        contactPerson: rowSelected?.contactPerson || "",
        npwp: rowSelected?.npwp || "",
        phone: rowSelected?.phone || "",
        top: rowSelected?.top || "",
        creditScore: rowSelected?.creditScore || ""
    };

    const [selectedTitle, setSelectedTitle] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [defaultValueModal, setDefaultValueModal] = useState(false);

    const titleOptions = useMemo(() =>
        customerTitle.map(title => ({
            value: title.id,
            label: title.titleName,
        })), [customerTitle]);

    const typeOptions = useMemo(() =>
        customerType.map(type => ({
            value: type.id,
            label: type.name,
        })), [customerType]);

    const handleSelectTitle = (selectedOption, setFieldValue) => {
        setSelectedTitle(selectedOption);
        setFieldValue('title.id', selectedOption ? selectedOption.value : null);
    };

    const handleSelectType = (selectedOption, setFieldValue) => {
        setSelectedType(selectedOption);
        setFieldValue('type.id', selectedOption ? selectedOption.value : null);
    };

    useEffect(() => {
        if (showEditCustomer) {
            const defaultSelected = titleOptions.find(
                option => option.value === rowSelected?.title?.id
            );
            const defaultSelectedType = typeOptions.find(
                option => option.value === rowSelected?.customerType?.id
            );

            setSelectedTitle(defaultSelected || null);
            setSelectedType(defaultSelectedType || null);

            setDefaultValueModal(true);
        }
    }, [showEditCustomer, rowSelected, titleOptions, typeOptions]);

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
        },
    };

    const handleDelete = async (rowId) => {
        const result = await Swal.fire({
            title: 'Hapus Alamat?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            try {
                const response = await axiosAuth.delete(`/api/customers/addresses/${rowId}`,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                Swal.fire('Berhasil!', 'Alamt berhasil dihapus', 'success');
                retrieveCustomerAddress();
            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'Terjadi kesalahan saat menghapus alamat!', 'error');
            }
        } else {
            <></>
        }
    };

    const handleSubmitCustomer = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const dataCustomer = {
            name: values?.customerName,
            phone: values?.phone,
            contactPerson: values?.contactPerson,
            email: values?.email,
            top: values?.top,
            npwp: values?.npwp,
            creditScore: values?.creditScore,
            titleId: selectedTitle?.value,
            customerTypeId: selectedType?.value
        };

        try {

            const response = await axiosAuth.put(`/api/customers/${rowSelected?.id}`, dataCustomer, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Customer',
                showConfirmButton: true,
            });

            retrieveCustomer();

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            if (err.response?.status === 400) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: `${err.response?.data.message}`,
                });

            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Terjadi kesalahan saat mengupdate Lead',
                });
            }

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }

    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    const [modalMode, setModalMode] = useState('');

    const [showEditAlamat, setShowEditAlamat] = useState(false);
    const [rowAlamat, setRowAlamat] = useState();

    const handleShowEditAlamat = (addr) => {
        setShowEditAlamat(true);
        setRowAlamat(addr);
        setModalMode('Ubah')
    };

    const handleCloseEditAlamat = () => {
        setShowEditAlamat(false);
        setRowAlamat(undefined); // clear previous data
    };

    const [showAddAlamat, setShowAddAlamat] = useState(false);

    const handleShowAddAlamat = () => {
        setShowAddAlamat(true)
        setModalMode('Tambah');

    };

    const handleCloseAddAlamat = () => {
        setShowAddAlamat(false);
        setRowAlamat(undefined); // clear previous data
    };

    const [addressType, setAddressType] = useState(null);

    const adressTypeOptions = [
        {
            value: 'Kantor',
            label: 'Kantor',
        },
        {
            value: 'Penagihan',
            label: 'Penagihan',
        },
        {
            value: 'Pengiriman',
            label: 'Pengiriman',
        },
    ];

    const defaultValueAlamat = {
        addressType: rowAlamat?.addressType || "",
        isDefault: rowAlamat?.isDefault ?? false,
        pic: rowAlamat?.pic || "",
        phone: rowAlamat?.phone || "",
        city: rowAlamat?.city || "",
        province: rowAlamat?.province || "",
        postCode: rowAlamat?.postCode || "",
        address: rowAlamat?.address || "",
    };

    const handleSelectAddressType = (selectedOption, setFieldValue) => {
        setFieldValue("addressType", selectedOption ? selectedOption.value : null);
    };

    const modalStyle = {
        center: {
            position: 'absolute',
            zIndex: 1200, // ensure it's above the backdrop
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }
    }

    const [isSubmittingAddress, setIsSubmittingAddress] = useState(false);

    const handleSubmitNewAddress = async (values) => {

        setIsSubmittingAddress(true);
        setDisabled(true);

        const dataCustomerAddress = {
            ...values,
            customerId: rowSelected?.id,
            username: userInfo?.username,
        };

        const arrayAddress = [dataCustomerAddress]

        try {

            const responseAddress = await axiosAuth.post(`/api/customers/addresses`, arrayAddress, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleCloseAddAlamat();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil menambahkan Alamat Customer',
                showConfirmButton: true,
            });
            retrieveCustomerAddress();
            setIsSubmittingAddress(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat menambahkan Alamat Customer',
            });

            setIsSubmittingAddress(false);
            setDisabled(false);

        } finally {

            setIsSubmittingAddress(false);
            setDisabled(false);

        }
    };

    const handleSubmitEditAddress = async (values) => {

        setIsSubmittingAddress(true);
        setDisabled(true);

        const dataCustomerAddress = {
            ...values,
            customerId: rowAlamat?.customer.id,
            username: userInfo?.username,
        };

        try {

            const responseAddress = await axiosAuth.put(`/api/customers/addresses/${rowAlamat?.id}`, dataCustomerAddress, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleCloseEditAlamat();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah Alamat Customer',
                showConfirmButton: true,
            });
            // retrieveCustomer();
            retrieveCustomerAddress();
            setIsSubmittingAddress(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah Alamat Customer',
            });

            setIsSubmittingAddress(false);
            setDisabled(false);

        } finally {

            setIsSubmittingAddress(false);
            setDisabled(false);

        }
    };

    const filteredCustomerAddress = customerAddress.filter((address) => address?.isDefault == true);

    const handleSubmitCustomerAddress = async (values) => {
        if (modalMode === "Tambah") {
            handleSubmitNewAddress(values);
        } else if (modalMode === "Ubah") {
            handleSubmitEditAddress(values);
        }
    };

    return (
        <Modal
            show={showEditCustomer}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='xl'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Ubah Customer
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col style={{ borderRight: isMobile ? '' : '1px solid #acacac' }}>
                        <Formik
                            initialValues={defaultValue}
                            enableReinitialize={true}
                            onSubmit={handleSubmitCustomer}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                setFieldValue
                            }) => (
                                <Form onSubmit={handleSubmit} className='mx-2'>
                                    <Row>
                                        <Col xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='customerName'>Nama Customer</Form.Label>
                                                <Form.Control
                                                    id='customerName'
                                                    type='text'
                                                    value={values.customerName}
                                                    onChange={handleChange("customerName")}
                                                    required
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='title'>Title*</Form.Label>
                                                <Select
                                                    id='title'
                                                    options={titleOptions}
                                                    required
                                                    value={selectedTitle}
                                                    onChange={option => handleSelectTitle(option, setFieldValue)}
                                                    styles={selectStyles}
                                                    isDisabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='type'>Tipe Customer *</Form.Label>
                                                <Select
                                                    id='type'
                                                    options={typeOptions}
                                                    required
                                                    value={selectedType}
                                                    onChange={option => handleSelectType(option, setFieldValue)}
                                                    styles={selectStyles}
                                                    isDisabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='email'>Email</Form.Label>
                                                <Form.Control
                                                    id='email'
                                                    type='email'
                                                    value={values.email}
                                                    onChange={handleChange("email")}
                                                    required
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='contactPerson'>Contact Person</Form.Label>
                                                <Form.Control
                                                    id='contactPerson'
                                                    type='text'
                                                    value={values.contactPerson}
                                                    onChange={handleChange("contactPerson")}
                                                    required
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='phone'>Phone</Form.Label>
                                                <Form.Control
                                                    id='phone'
                                                    type='text'
                                                    value={values.phone}
                                                    onChange={handleChange("phone")}
                                                    required
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Finance'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='npwp'>Npwp</Form.Label>
                                                <Form.Control
                                                    id='npwp'
                                                    type='text'
                                                    value={values.npwp}
                                                    required
                                                    onChange={handleChange("npwp")}
                                                    disabled={userInfo?.role?.roleName === 'Finance'}
                                                    style={formStyles?.input}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='top'>Term of Payment (Hari)</Form.Label>
                                                <Form.Control
                                                    id='nptopwp'
                                                    type='text'
                                                    value={values.top}
                                                    onChange={handleChange("top")}
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Admin'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label style={formStyles.label} htmlFor='creditScore'>Credit Score</Form.Label>
                                                <Form.Control
                                                    id='creditScore'
                                                    type='number'
                                                    value={values.creditScore}
                                                    onChange={(e) => {
                                                        const value = e.target.value;

                                                        // Allow only numbers
                                                        if (value === '' || /^[0-9\b]+$/.test(value)) {
                                                            // Check if number exceeds 5
                                                            if (Number(value) > 5) {
                                                                Swal.fire({
                                                                    icon: 'warning',
                                                                    title: 'Invalid Credit Score',
                                                                    text: 'Credit Score cannot be greater than 5!',
                                                                });
                                                                return; // Don't update the form value
                                                            }

                                                            handleChange("creditScore")(e); // If okay, proceed
                                                        }
                                                    }}
                                                    style={formStyles?.input}
                                                    disabled={userInfo?.role?.roleName === 'Admin'}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="d-grid gap-2 mb-2 mt-3">
                                        {isSubmitting ? (
                                            <Button
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                variant='btn'
                                                disabled
                                            >
                                                <Spinner
                                                    animation="border"
                                                    size='sm'
                                                />
                                            </Button>
                                        ) : (
                                            <Button
                                                type="submit"
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                variant='btn'
                                                disabled={disabled}
                                            >
                                                Simpan
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                    <Col>
                        <div className='mx-2'>
                            <Row className='mb-3'>
                                <Col xs={6} className='text-start my-auto'>
                                    <p style={{ color: theme === 'light' ? 'white' : '#222', fontFamily: 'Poppins-Medium', marginBottom: '0px' }}>
                                        * Alamat Customer
                                    </p>
                                </Col>
                                {userInfo?.role?.roleName === 'Admin' ?
                                    (
                                        <Col xs={6} className='text-end'>
                                            <Button
                                                variant='btn'
                                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                onClick={handleShowAddAlamat}
                                            >
                                                Tambah
                                            </Button>
                                        </Col>
                                    )
                                    :
                                    (
                                        <></>
                                    )
                                }
                            </Row>
                            <div style={{ overflowX: 'auto', height: '450px' }}>
                                {customerAddress.map((addr, idx) => (
                                    <Card className='mb-3' style={{ minHeight: '100px' }} key={idx}>
                                        <Card.Body>
                                            <Row>
                                                <Col xs={10} className='text-start'>
                                                    {addr?.isDefault === true ?
                                                        (
                                                            <>
                                                                <p className='mb-1 ' style={{ fontFamily: 'Poppins-Regular', fontSize: '18px', color: theme === 'light' ? '#12B3ED' : '#006CB8' }}>
                                                                    Alamat Utama*
                                                                </p>
                                                                <p className='mb-1' style={{ fontFamily: 'Poppins-Bold', fontSize: '18px' }}>
                                                                    {addr.addressType}
                                                                </p>
                                                            </>
                                                        )
                                                        :
                                                        (
                                                            <p className='mb-1' style={{ fontFamily: 'Poppins-Bold', fontSize: '18px' }}>
                                                                {addr.addressType}
                                                            </p>
                                                        )
                                                    }
                                                    <p className='mb-0' style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                        {addr.pic} ( {addr.phone} )
                                                    </p>
                                                    <p className='mb-0' style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                        {addr.address}
                                                    </p>
                                                    <p style={{ fontFamily: 'Poppins-Regular', fontSize: '16px' }}>
                                                        {addr.city},  {addr.province}, {addr.postCode}
                                                    </p>
                                                </Col>
                                                <Col xs={2} className='text-end my-auto'>
                                                    <div className='mb-3'>
                                                        <Button
                                                            style={{ backgroundColor: 'none', border: 'none' }}
                                                            variant='btn'
                                                            disabled={userInfo?.role?.roleName === 'Finance'}
                                                        >
                                                            <BsFillPencilFill
                                                                className='me-2'
                                                                size={25}
                                                                onClick={() => handleShowEditAlamat(addr)}
                                                                color={theme == 'light' ? '#12B3ED' : '#006CB8'}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Button>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            style={{ backgroundColor: 'none', border: 'none' }}
                                                            variant='btn'
                                                            disabled={addr?.isDefault ? true : false || userInfo?.role?.roleName === 'Finance'}
                                                        >
                                                            <MdDeleteForever
                                                                size={35}
                                                                onClick={() => handleDelete(addr?.id)}
                                                                color='#FF0060'

                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>

            {/* Customer Address Modal */}

            <Modal
                show={modalMode === 'Tambah' ? showAddAlamat : showEditAlamat}
                onHide={modalMode === 'Tambah' ? handleCloseAddAlamat : handleCloseEditAlamat}
                backdrop="static"
                keyboard={false}
                size='md'
                centered
                style={modalStyle.center}
                data-bs-theme={theme === 'light' ? 'dark' : ''}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={formStyles.label}>
                        {modalMode === 'Tambah' ? 'Tambah Alamat' : 'Ubah Alamat'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={defaultValueAlamat}
                        enableReinitialize={true}
                        onSubmit={handleSubmitCustomerAddress}
                    >
                        {({ handleSubmit,
                            values,
                            setFieldValue
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col
                                        xs={
                                            (filteredCustomerAddress.length !== 0 && modalMode === 'Tambah')
                                                ? 12
                                                : (rowAlamat?.isDefault === true || filteredCustomerAddress.length === 0)
                                                    ? 7
                                                    : 12
                                        }
                                        lg={
                                            (filteredCustomerAddress.length !== 0 && modalMode === 'Tambah')
                                                ? 12
                                                : (rowAlamat?.isDefault === true || filteredCustomerAddress.length === 0)
                                                    ? 8
                                                    : 12
                                        }
                                    >
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='addressType'>Tipe Alamat*</Form.Label>
                                            <Select
                                                id="addressType"
                                                required
                                                options={adressTypeOptions}
                                                value={adressTypeOptions.find((option) => option.value === values.addressType) || null}
                                                onChange={(selectedOption) => handleSelectAddressType(selectedOption, setFieldValue)}
                                                styles={selectStyles}
                                                placeholder="Pilih tipe alamat"
                                            />
                                        </Form.Group>
                                    </Col>
                                    {filteredCustomerAddress.length !== 0 && modalMode === 'Tambah' ?
                                        (

                                            <></>
                                        )
                                        :
                                        (
                                            <>
                                                {rowAlamat?.isDefault == true || filteredCustomerAddress.length == 0 ?
                                                    (
                                                        <Col xs={5} lg={4} className="mb-3">
                                                            <Form.Label style={formStyles.label}>Alamat Utama*</Form.Label>
                                                            <Form.Check
                                                                type='checkbox'
                                                                id='default-checkbox'
                                                                checked={values.isDefault}
                                                                onChange={(e) => setFieldValue("isDefault", e.target.checked)}
                                                                style={formStyles.label}
                                                            />
                                                        </Col>
                                                    )
                                                    :
                                                    (
                                                        <></>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    <Col xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor="pic">PIC*</Form.Label>
                                            <Form.Control
                                                id="pic"
                                                type="text"
                                                value={values.pic}
                                                onChange={(e) => { setFieldValue("pic", e.target.value); }}
                                                style={formStyles.input}
                                                placeholder='Nama pic'
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='phone'>Phone*</Form.Label>
                                            <Form.Control
                                                id='phone'
                                                type='text'
                                                value={values.phone}
                                                onChange={(e) => { setFieldValue("phone", e.target.value); }}
                                                required
                                                placeholder='Phone'
                                                style={formStyles.input}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='city'>Kota*</Form.Label>
                                            <Form.Control
                                                id='city'
                                                type='text'
                                                value={values.city}
                                                onChange={(e) => { setFieldValue("city", e.target.value); }}
                                                required
                                                placeholder='Kota'
                                                style={formStyles.input}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='province'>Provinsi*</Form.Label>
                                            <Form.Control
                                                id='province'
                                                type='text'
                                                value={values.province}
                                                onChange={(e) => { setFieldValue("province", e.target.value); }}
                                                required
                                                placeholder='Kota'
                                                style={formStyles.input}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='postCode'>Kode Pos*</Form.Label>
                                            <Form.Control
                                                id='postCode'
                                                type='text'
                                                value={values.postCode}
                                                onChange={(e) => { setFieldValue("postCode", e.target.value); }}
                                                required
                                                placeholder='Kota'
                                                style={formStyles.input}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='postCode'>Detail Alamat*</Form.Label>
                                            <Form.Control
                                                id='address'
                                                as='textarea'
                                                rows={5}
                                                value={values.address}
                                                onChange={(e) => { setFieldValue("address", e.target.value); }}
                                                required
                                                placeholder='Detail alamat'
                                                style={formStyles.input}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="d-grid gap-2 mt-4">
                                    {isSubmittingAddress ? (
                                        <Button
                                            id={
                                                theme === "light"
                                                    ? "actionButtonModalDark"
                                                    : "actionButtonModalLight"
                                            }
                                            variant="btn"
                                            disabled
                                        >
                                            <Spinner animation="border" size="sm" />
                                        </Button>
                                    ) : (
                                        <Button
                                            type="submit"
                                            id={
                                                theme === "light"
                                                    ? "actionButtonModalDark"
                                                    : "actionButtonModalLight"
                                            }
                                            variant="btn"
                                            disabled={disabled ||
                                                !values?.addressType ||
                                                !values?.pic ||
                                                !values.phone ||
                                                !values.city ||
                                                !values.province ||
                                                !values.postCode ||
                                                !values.address
                                            }
                                        >
                                            Simpan
                                        </Button>
                                    )}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            {/* Customer Address Modal */}

        </Modal>
    )
}

export default ModalUbahCustomer
